var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Hero',{attrs:{"title":"Torneios","message":'Informação de torneios live',"icon":"mdi-trophy-award","layout_type":"video","navigation-month":true,"calendar":""}}),_c('v-container',{staticClass:"my-3"},[_c('TableLiveListTournaments')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }